export const apicall = (link) => fetch(link).then(res => res.json())